var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseDiffPan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.5,
    height: 126.098,
    viewBox: "0 0 126.5 126.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1660",
    width: 89.875,
    height: 114.937,
    x: 0,
    y: 11.161,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2,.cls-3{fill:#fff}.cls-2{opacity:.4}.cls-3{opacity:.2}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_158_1",
    transform: "translate(1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6380",
    transform: "translate(-619.789 -207.199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1666",
    width: 62.765,
    height: 89.777,
    fill: "#7fb3f8",
    rx: 7,
    transform: "rotate(3 -3810.643 12961.535)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671",
    width: 50,
    height: 30,
    className: "cls-2",
    rx: 2,
    transform: "rotate(2.98 -3960.943 13173.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1669",
    width: 8,
    height: 40,
    className: "cls-3",
    rx: 2,
    transform: "rotate(2.98 -4691.792 13141.334)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670",
    width: 3.377,
    height: 40,
    className: "cls-3",
    rx: 1.689,
    transform: "rotate(2.98 -4724.067 13476.039)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1667",
    width: 3.377,
    height: 21,
    className: "cls-3",
    rx: 1.689,
    transform: "rotate(2.98 -5100.274 13581.227)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674",
    width: 3.377,
    height: 21,
    className: "cls-3",
    rx: 1.689,
    transform: "rotate(2.98 -5104.156 13695.943)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668",
    width: 3.377,
    height: 21,
    className: "cls-3",
    rx: 1.689,
    transform: "rotate(2.98 -5087.166 14046.02)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Rectangle_1660)",
    transform: "translate(618.29 207.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1660-2",
    width: 62.765,
    height: 89.777,
    fill: "#0663e2",
    rx: 7,
    transform: "rotate(-4 378.094 -137.32)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1661",
    width: 50,
    height: 30,
    className: "cls-2",
    rx: 2,
    transform: "matrix(.998 -.07 .07 .998 636.062 238.982)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1663",
    width: 3.377,
    height: 40,
    className: "cls-3",
    rx: 1.689,
    transform: "matrix(.998 -.07 .07 .998 649.146 276.982)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1664",
    width: 3.377,
    height: 21,
    className: "cls-3",
    rx: 1.689,
    transform: "matrix(.998 -.07 .07 .998 656.472 294.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    width: 3.377,
    height: 21,
    className: "cls-3",
    rx: 1.689,
    transform: "matrix(.998 -.07 .07 .998 663.11 294.393)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1665",
    width: 3.377,
    height: 21,
    className: "cls-3",
    rx: 1.689,
    transform: "rotate(-4.01 4522.985 -9654.13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1672",
    fill: "none",
    d: "M0 0H125V125H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseDiffPan);
export default __webpack_public_path__ + "static/media/useDiffPan.101bf91dc4625271ed3e9a10c62ae41d.svg";
export { ForwardRef as ReactComponent };